import { get } from 'lodash-es'

const mappingTable = {
  NavigationLaunchPortal: 'NavigationItem',
}

export const mapItem = item => get(mappingTable, item, item)

export default {
  NavigationItem: () =>
    import(
      /* webpackChunkName: "NavigationItem" */ '@/js/components/Navigation/NavigationItem.vue'
    ),
  NavigationBrandItem: () =>
    import(
      /* webpackChunkName: "NavigationBrandItem" */ '@/js/components/Navigation/NavigationBrandItem.vue'
    ),
  NavigationIconItem: () =>
    import(
      /* webpackChunkName: "NavigationIconItem" */ '@/js/components/Navigation/NavigationIconItem.vue'
    ),
  NavigationIconTextItem: () =>
    import(
      /* webpackChunkName: "NavigationIconTextItem" */ '@/js/components/Navigation/NavigationIconTextItem.vue'
    ),
  NavigationSeparatorItem: () =>
    import(
      /* webpackChunkName: "NavigationSeparatorItem" */ '@/js/components/Navigation/NavigationSeparatorItem.vue'
    ),
  NavigationImagesItem: () =>
    import(
      /* webpackChunkName: "NavigationImagesItem" */ '@/js/components/Navigation/NavigationImagesItem.vue'
    ),
  NavigationButtonItem: () =>
    import(
      /* webpackChunkName: "NavigationButtonItem" */ '@/js/components/Navigation/NavigationButtonItem.vue'
    ),
}
